import { useTranslation } from 'react-i18next';

import { AreaValue } from '@client/api';

import { toNumberStringOrUndefined } from '../numberUtils';

type Area = AreaValue | null;

export const useAreaMetricString = (
  area?: Area
) => {
  const { t: tType } = useTranslation('type');

  return toNumberStringOrUndefined(area?.metric ?? undefined, undefined, {
    unit: tType('AreaMeasurementUnit.SquareMeters', { context: 'short' }),
  });
}
